<template>
  <div class="lamps-page" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head" label-width="110px">
        <el-row :gutter="20" class="list-head">
          <el-col :span="4">
            <el-form-item :label="$t('device.device_number')">
              <el-input v-model="filter.number" :placeholder="$t('device.please_device_number')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('device.device_name')">
              <el-input v-model="filter.name" :placeholder="$t('device.please_device_name')" clearable/>
            </el-form-item>
          </el-col>
          <el-col v-if="$store.state.user.role_type==1" :span="4">  
            <el-form-item :label="$t('device.company')">
              <el-select
                clearable
                filterable
                :placeholder="$t('device.select_company')"
                v-model="filter.company_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in companyList"
                  :key="t.company_id"
                  :label="t.company_name"
                  :value="t.company_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4"> 
            <el-form-item :label="$t('device.project')">
              <el-select
                clearable
                filterable
                :placeholder="$t('device.select_project')"
                v-model="filter.project_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in projectList"
                  :key="t.project_id"
                  :label="t.project_name"
                  :value="t.project_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('device.group')">
              <el-select
                clearable
                filterable
                :placeholder="$t('device.select_group')"
                v-model="filter.lamp_group"
                style="width: 100%"
              >
                <el-option
                  v-for="t in lampGroupList"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('device.state')">
              <el-select
                clearable
                :placeholder="$t('device.select_state')"
                v-model="filter.ste"
                style="width: 100%"
              >
              <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option
                  v-for="(t,index) in steList"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4"> 
            <el-form-item :label="$t('device.strategy')">
              <el-select
                clearable
                filterable
                :placeholder="$t('device.select_strategy')"
                v-model="filter.stg_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in strategyList"
                  :key="t.id"
                  :label="t.title"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('device.time_frame')">
              <el-date-picker
                v-model="filterDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('control.to')"
                :start-placeholder="$t('control.start_date')"
                :end-placeholder="$t('control.over_date')"
                @change="clearChange"
                />
            </el-form-item>
          </el-col>

          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            >
            <svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}
          </el-button>
          <div class="control_type">
            <el-button type="primary" class="insert-btn" @click="exportFile.visible = true">
              <svg-icon name="import"></svg-icon>{{$t('control.batch_import')}}
            </el-button>
            <div class="other_text"><a href="https://www.forido.net/static/upload/xlsx/模板.xlsx" target="_blank">{{$t('control.down_temp')}}</a></div>
          </div>
        </div>
        <div class="group-right">
          <div class="auto_mode">
            <div class="other_text">{{$t('device.batch_set_mode')}}</div>
            <el-button type="primary" @click="contorlType(0)" round>{{$t('control.all_auto')}}</el-button>
            <el-button type="info"  @click="contorlType(1)" round>{{$t('control.all_manual')}}</el-button>
          </div>
          <el-button type="primary" @click="allOpen.visible = true" round>{{$t('control.all_open')}}</el-button>
          <el-button type="info"  @click="lightContorl(0)" round>{{$t('control.all_close')}}</el-button>
        </div>
      </div>
      <el-table 
        :data="tableData"
        style="width: 100%"
        ref="table"
        class="nowrap-table"
        >
        <el-table-column prop="number" :label="$t('device.device_number')" align="center" sortable :min-width="200"></el-table-column>
        <el-table-column prop="name" :label="$t('device.device_name')" align="center" width="180"></el-table-column>
        <el-table-column :label="$t('device.device_model')" width="140" align="center">
          <template slot-scope="scope">
            {{ scope.row.device_type_name?scope.row.device_type_name: '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('device.single_Double')" prop="is_double" width="160" align="center">
          <template slot-scope="scope">
            {{ doubleType[scope.row.is_double] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('device.switch_state')" prop="lights_status" align="center"  width="160" sortable>
          <template slot-scope="scope">
            <i :class="lightStatusArr[scope.row.lights_status]"></i>
            <span>{{ lightStatus[scope.row.lights_status] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brightness" :label="$t('device.light_control')" align="center" width="140">
          <template slot-scope="scope">
            <div class="light-control-box">
              <span>{{ scope.row.brightness }}</span>
              <i class="el-icon-setting control-icon" @click="showSet(scope.row)"></i>
              <span class="grey">{{ msList[scope.row.ms] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stg_name" :label="$t('device.current_strategy')" align="center" width="160"></el-table-column>
        <el-table-column prop="ste" :label="$t('device.online_status')"  width="160" align="center" sortable>
          <template slot-scope="scope">
            <i :class="steColorArr[scope.row.ste]"></i>
            <span>{{ steList[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="group_name" :label="$t('device.group')" align="center" width="120"></el-table-column>
        <el-table-column prop="current" :label="$t('device.current')" align="center" width="120"></el-table-column>
        <el-table-column prop="voltage" :label="$t('device.voltage')" align="center" width="120"></el-table-column>
        <el-table-column prop="lamp_type" :label="$t('device.show_data')" align="center" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.lamp_type=='3'||scope.row.lamp_type=='4'" class="blue" @click="openLampOtherInfo(scope.row.lamp_id, scope.row.name)">{{$t('device.show_data')}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" fixed="right" width="110">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.lamp_id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>

    <!-- 编辑设备信息弹窗 -->
    <el-dialog 
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible">
      <el-form
        :model="editOne"
        :rules="editOneRule"
        ref="dialogRef"
        label-width="120px"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="12">
            <el-form-item :label="$t('device.select_protocol')">
              <el-select
                :placeholder="$t('device.select_protocol')"
                v-model="editOne.lamp_type"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in lampTypeList"
                  v-if="index !== 0"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.device_number')" prop="number">
              <el-input v-model="editOne.number"></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.device_name')" prop="name">
              <el-input v-model="editOne.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.single_Double')">
              <el-select
                :placeholder="$t('device.select_single_Double')"
                v-model="editOne.is_double"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in doubleType"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="editOne.lamp_type==4" :label="$t('device.gateway_number')"> 
              <el-input v-model="editOne.gateway"></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.group')"> 
              <el-select
                :placeholder="$t('device.select_group')"
                v-model="editOne.lamp_group"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="t in lampGroupList"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.strategy')">
              <el-select
                :placeholder="$t('device.select_strategy')"
                v-model="editOne.stg_id"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="t in strategyList"
                  :key="t.id"
                  :label="t.title"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.project')">
              <el-select
                clearable
                filterable
                :placeholder="$t('device.select_project')"
                v-model="editOne.project_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in projectList"
                  :key="t.project_id"
                  :label="t.project_name"
                  :value="t.project_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.is_home')">
              <div class="checkbox-item">
                <el-checkbox v-model="editOne.is_display" :true-label="1" :false-label="0"></el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20" class="item-list">
              <el-col :span="24">
                <div class="map-box">
                  <amap :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
                </div>
                <div class="h20"></div>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('control.longitude')" class="lnglat-input">
                  <el-input v-model="editOne.longitude" @input="onInput()" style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('control.latitude')" class="lnglat-input">
                  <el-input v-model="editOne.latitude" @input="onInput()" style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('device.is_sensor')" class="r-label">
                  <div class="checkbox-item">
                    <el-checkbox v-model="editOne.is_sensor" :true-label="1" :false-label="0"></el-checkbox>
                  </div>
                </el-form-item>
              </el-col>
              
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          size="medium"
          class="cancel-btn"
          @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button >

        <el-button
          type="primary"
          size="medium"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button>
      </div>
    </el-dialog>

    <!-- 设备控制设置 -->
    <div
      v-if="lightSetItem.visible"
      class="box_control_bg"
      @click="closeSet"
    ></div>
    <div v-if="lightSetItem.visible" class="box_control w750">
      <div class="box_head">
        <span class="box_title">{{ lightSetItem.title }}-{{$t('device.light_control')}}</span>
        <div class="box_close" @click="closeSet">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <light-set
          ref="lightSet"
          :setData="lightSetItem.lightSetData"
          @updated="getTableData(pageInfo.page)"
        ></light-set>
      </div>
    </div>

    <!-- 全开-亮度控制 -->
    <el-dialog class="dialog600" :title="$t('device.all_open')+'-'+$t('device.light_control')" :visible.sync="allOpen.visible">
      <div class="box_body p_b20">
        <el-slider
          v-model="allOpen.light"
          :min="1"
          :max="100"
          show-input
        ></el-slider>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="allOpen.visible = false,allOpen.visible = false,allOpen.light = 0">{{$t('control.cancel')}}</el-button>
        <el-button type="primary" @click="(allOpen.visible = false), lightContorl(1)"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!-- 批量导入 -->
    <el-dialog class="dialog600" :title="$t('control.batch_import')" :visible.sync="exportFile.visible">
      <div class="box_body">
        <el-form
          :model="exportFile"
          label-position="left"
          label-width="100px"
        >
          <el-form-item :label="$t('control.project')">
            <el-select
              clearable
              filterable
              :placeholder="$t('control.select_project')"
              v-model="exportFile.project_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in projectList"
                :key="t.project_id"
                :label="t.project_name"
                :value="t.project_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('control.select_protocol')">
            <el-select
              clearable
              :placeholder="$t('control.select_protocol')"
              v-model="exportFile.lamp_type"
              style="width: 100%"
            >
              <el-option  
                v-for="(t,index) in lampTypeList" 
                v-if="index !== 0"
                :key="index"
                :label="t"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('control.file_upload')">
            <el-upload
              ref="upload"
              name="file"
              :action="uploadAction()"
              :limit="1"
              :file-list="fileList"
              :headers="{'Authorization': token}"
              :data="{'type': 3}"
              :on-remove="handleRemove"
              :beforeUpload="beforeFilesUpload"
              :on-success="handleFilesSuccess"
            >
              <el-button size="small" type="primary">{{$t('control.select_file')}}</el-button>
            </el-upload>
          </el-form-item>
          </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportExcel(0)">{{$t('control.cancel')}}</el-button>
        <el-button type="primary" @click="exportExcel(1)"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--路灯其他信息-->
    <el-dialog
      v-if="lampOtherInfo.dialogVisible"
      :visible.sync="lampOtherInfo.dialogVisible"
      class="dialog800"
      :title="'['+lampOtherInfo.name +']'+$t('device.detail')"
    >
      <lamp-other-info
        ref="lampOtherInfo"
        :id="lampOtherInfo.id"
        @closeMethod="closeLampOtherInfo"
      ></lamp-other-info>
    </el-dialog>

  </div>
</template>

<script>
import lampsApi from "@/api/device/lamps";
import lampGroupApi from "@/api/device/lampGroup";
import strategyApi from "@/api/device/strategy";
import projectApi from "@/api/system/project";
import companyApi from "@/api/system/company";
import commonJs from '@/utils/common'
import lightSet from "@/components/device/lamps/lightControl"
import lampOtherInfo from "@/components/device/lamps/lampOtherInfo"
import amap from '@/components/addMap'
import { getToken } from '@/utils/auth'
import { ACCOUNT_MAP } from '@/config/index.js';
export default {
  components: {
    amap,
    lightSet,
    lampOtherInfo
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      center: [],
      tableData: [],
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        number: '',
        name: '',
        company_id: '',
        stg_id: '',
        project_id: '',
        lamp_group: '', // 分组id
        ste: '', // 0离线、1在线
        createTimeFrom: '', // 时间间隔开始
        createTimeTo: '' // 时间间隔结束
      },
      filterDate: [],
      lampTypeList: this.$t('device.lampTypeList'),
      doubleType: this.$t('device.doubleType'),
      steColorArr: ["valuegrey", "valuegreen"],
      steList: this.$t('device.steList'),
      lightStatusArr: ["valuegrey", "valueyellow"],
      lightStatus: this.$t('device.lightStatus'),
      msList: this.$t('device.msList'),
      projectList: [],
      strategyList: [],
      companyList: [],
      lampGroupList: [],
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: this.$t('device.please_device_name'), trigger: "blur" }],
        number: [{ required: true, message: this.$t('device.please_device_number'), trigger: "blur" }],
      },
      editType: -1,
      editOne: {},
      lightSetItem: {
        visible: false,
        title: "",
        lightSetData: {}
      },
      freq: {
        visible: false,
        levelArr: this.$t('device.freq_level_arr'),
        data: []
      },
      exportFile: {
        visible: false,
        lamp_type: 1,
        project_id: '',
        file: ''
      },
      allOpen: {
        visible: false,
        light: 0
      },
      token: getToken(),
      fileList: [],
      lampOtherInfo: {
        id: null,
        name: '',
        dialogVisible: false
      }
    };
  },
  async created() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }
    this.center = mapData.center

    this.getTableData(this.pageInfo.page)
    this.getCompanyList()
    this.getProjectList()
    this.getLampGroupList()
    this.getStrategyList()
  },
  methods: {
    // 获取列表
    getTableData(pageIndex) {
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      [this.filter.createTimeFrom, this.filter.createTimeTo] = this.filterDate || ['', '']
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false
          let resData = res.data.data
          this.tableData = resData.list
          this.pageInfo.page = pageIndex
          this.cnt_all = parseInt(resData.count)
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.getTableData(this.pageInfo.page)
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.getTableData(this.pageInfo.page)
    },
    getCompanyList() {
      companyApi.getCompany({
        sortBy: 'company_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data;
        this.companyList = resData.list;
      });
    },
    getProjectList() {
      projectApi.getProject({
        sortBy: 'project_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data
        this.projectList = resData.list
      });
    },
    getLampGroupList() {
      lampGroupApi.lampGroupList({
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data;
        this.lampGroupList = resData.list;
      });
    },
    getStrategyList() {
      strategyApi.strategyList({
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data
        this.strategyList = resData.list
      });
    },
    async openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          lamp_type: 1,
          project_id: '',
          number: '',
          name: '',
          is_double: 0,
          lamp_group: '',
          stg_id: '',
          longitude: '',
          latitude: '',
          gateway: '',
          is_display: 1,
          is_sensor: 0
        };
        [this.editOne.longitude, this.editOne.latitude] = this.center
        this.editType = "create"
      } else {

        this.editOne = {
          lamp_id: index.lamp_id,
          lamp_type: parseInt(index.lamp_type),
          project_id: parseInt(index.project_id),
          number: index.number,
          name: index.name,
          is_double: index.is_double,
          lamp_group: parseInt(index.lamp_group),
          stg_id: parseInt(index.stg_id),
          longitude: index.longitude,
          latitude: index.latitude,
          gateway: index.gateway,
          is_display: index.is_display,
          is_sensor: index.is_sensor
        }

        if (!index.longitude && !index.latitude) [this.editOne.longitude, this.editOne.latitude] = this.center

        this.editType = "update"
      }
      this.dialogVisible = true
    },
    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          lampsApi.lightEdit(this.editOne.lamp_id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'))
              this.dialogVisible = false
              this.getTableData(this.pageInfo.page)
            } else {
              this.$message.error(res.data.message)
            }
          });
        }
      });
      
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          lampsApi.lightAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'))
              this.dialogVisible = false
              this.getTableData(this.pageInfo.page)
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
      
    },
    delItem(id) {
      this.$confirm(this.$t("control.tip_del_device_title"), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          lampsApi.lightDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'))
              this.getTableData(this.pageInfo.page)
            } else {
              this.$message.error(res.data.message)
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del')
          });
        });
    },
    lightContorl (light) {
      if(light==1){
        light=this.allOpen.light
      }
      const postData = {
        model: 1,
        light: light
      }
      lampsApi.lightControl(postData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.command_success'))
        }
      })
    },
    contorlType(type) {
      lampsApi.setAutoControl({
        type: type
      }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message)
          this.getTableData(this.pageInfo.page)
        } else {
          this.$message.error(res.data.message)
        }
      });
    },
    exportExcel(type) {
      const that = this
      if(type==0){
        that.exportFile = {
          visible: false,
          lamp_type: 1,
          project_id: '',
          file: ''
        }
      }else{
        lampsApi.importExcel({
          project_id: that.exportFile.project_id,
          file: that.exportFile.file,
          lamp_type: that.exportFile.lamp_type
        }).then((res) => {
          if (res.data.code === 1000) {
            that.$message.success(this.$t("control.import_success"))
            that.exportFile = {
              visible: false,
              lamp_type: 1,
              project_id: '',
              file: ''
            } 
            that.getTableData(that.pageInfo.page)
          } else {
            that.$message.error(res.data.message)
          }
        });
      }
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    showSet(setting) {
      this.lightSetItem.title = setting.name
      this.lightSetItem.lightSetData = {
        lamp_id: setting.lamp_id,
        lamp_name: setting.name,
        is_double: parseInt(setting.is_double),
        light: setting.light,
        light2: setting.light2,
        stg_id: setting.stg_id,
        stg_name: setting.stg_name,
        ms: setting.ms
      }
      this.lightSetItem.visible = true
    },
    closeSet() {
      this.lightSetItem.visible = false
      this.lightSetItem.title = ''
      this.lightSetItem.lightSetData = {}
      this.getTableData(this.pageInfo.page)
    },
    checkNoSelect(row, index) {
      let isChecked = true
      if (!row.ste) {
        isChecked = false
      }
      return isChecked
    },
    getCoordinate(map) {
      this.editOne.longitude = map.lng
      this.editOne.latitude = map.lat
    },
    onInput() {
      this.$forceUpdate();
    },
    uploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/system/uploadFile';
    },
    handleRemove() {
      this.fileList = []
      this.exportFile.file = ''
    },
    beforeFilesUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xlsx";
      if (!extension) {
        this.$message({
          message: this.$t("control.import_limitation"),
          type: "error",
        });
      }
      return extension;
    },
    handleFilesSuccess(res, file) {
      if (res.data.code === 1000) {
        this.$message.success(this.$t("control.upload_success"));
        this.exportFile.file = res.data.data.file_name;
        this.fileList[0]=res.data.data.file_url;
      } else {
        this.$message.error(this.$t("control.error") + res.data.message);
      }
    },
    formatDate(date) {
      return commonJs.formatDate(date);
    },
    clearChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.filterDate = ''
        })
      }
    },

    // 路灯其他详细信息
    openLampOtherInfo(id, name) {
      this.lampOtherInfo = {
        id: id,
        name: name,
        dialogVisible: true
      }
    },
    closeLampOtherInfo() {
      this.lampOtherInfo = {
        id: null,
        name: '',
        dialogVisible: false
      }
    }
    
  }
};
</script>
<style lang='less'>
.lamps-page {
  width: 100%;
  .control_type{
    display: flex;
    align-items: center;
  }
  .auto_mode{
    margin-right:50px;
    display: flex;
    align-items: center;
  }

  .dialog600.el-dialog__wrapper{
    .el-dialog__footer{
      padding:0 30px 30px;
    }
  }

  .lnglat-input{
    .el-form-item__label{
      width:80px !important
    }
    .el-form-item__content{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-input--mini{
        width:48%;
      }
      &::after, &::before{
        display: none;
      }
    }
  }

  .map-box{
    padding:0 13px;
    height: 330px;
    overflow: hidden;
  }
  .r-label{
    .el-form-item__label{
      width: 172px !important;
    }
  }
}
</style>